import { colors } from '../styles/colors';

interface LocationConsentModalProps {
  lang: string;
  onAccept: () => void;
  onDecline: () => void;
}

export default function LocationConsentModal({ lang, onAccept, onDecline }: LocationConsentModalProps) {
  const isKo = lang === 'ko';

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-sm rounded-2xl p-6" style={{ backgroundColor: colors.surface, border: `1.5px solid ${colors.border}` }}>
        <div className="mb-3 text-center text-3xl">📍</div>
        <h3 className="mb-2 text-center text-base font-bold" style={{ color: colors.text }}>
          {isKo ? '위치 정보 사용 안내' : 'Location Access'}
        </h3>
        <p className="mb-4 text-center text-xs leading-relaxed" style={{ color: colors.textMuted, wordBreak: 'keep-all' }}>
          {isKo
            ? 'OurHertz는 GPS 기반 무전기 채팅 서비스입니다. 사용자의 위치를 주파수로 변환하여 주변 사람들과 실시간으로 소통할 수 있게 합니다.\n\n위치 정보는 주파수 계산, 주변 사용자 탐색, 레이더 지도 표시에 사용됩니다. 위치를 허용하지 않아도 앱의 일부 기능은 사용할 수 있습니다.'
            : 'OurHertz is a GPS-based walkie-talkie chat service. Your location is converted into a frequency to connect you with nearby users in real time.\n\nLocation data is used for frequency calculation, nearby user discovery, and radar map display. You can still use some features if you decline.'}
        </p>
        <div className="flex gap-2">
          <button onClick={onDecline}
            className="flex-1 rounded-lg py-2.5 text-sm font-semibold"
            style={{ backgroundColor: colors.card, color: colors.textMuted, border: `1px solid ${colors.border}` }}>
            {isKo ? '나중에' : 'Not Now'}
          </button>
          <button onClick={onAccept}
            className="flex-1 rounded-lg py-2.5 text-sm font-bold text-white"
            style={{ backgroundColor: colors.primary }}>
            {isKo ? '위치 허용' : 'Allow Location'}
          </button>
        </div>
      </div>
    </div>
  );
}
